"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _client = require("@apollo/client");
var _utils = require("../utils");
var _error = require("@apollo/client/link/error");
var _reactToastify = require("react-toastify");
const defaultOptions = {
  watchQuery: {
    fetchPolicy: "network-only",
    errorPolicy: "ignore"
  },
  query: {
    fetchPolicy: "network-only",
    errorPolicy: "all"
  }
};
const cache = new _client.InMemoryCache({
  addTypename: false
});
function logout() {
  localStorage.setItem("logout-triggered", "logout" + Math.random());
  sessionStorage.clear();
  localStorage.removeItem("sessionId");
  localStorage.removeItem("jwtToken");
  const hostname = window.location.hostname.replace(/^[^.]+\./g, "");
  const port = window.location.port === "" ? "" : ":".concat(window.location.port);
  var masterUrl = "".concat(window.location.protocol, "//").concat(hostname).concat(port);
  var logoutUrl = masterUrl + "/applogout";
  if (window.location.href !== logoutUrl) window.location.href = logoutUrl;
}
var _default = exports.default = function _default(uri) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const authMiddleware = new _client.ApolloLink((operation, forward) => {
    const headers = {
      LoggerTraceId: (options.appName || "EL") + "-" + new _utils.IDGenerator().generate()
    };
    if (typeof window !== "undefined" && localStorage.getItem("jwttknkey")) {
      // add the authorization to the headers
      headers.JWTTKNCKEY = sessionStorage.getItem("jwtPersonaKey") ? sessionStorage.getItem("jwtPersonaKey") : localStorage.getItem("jwttknkey");
    } else if (localStorage.getItem("rdsjwCacheKey")) {
      headers.JWTTKNCKEY = localStorage.getItem("rdsjwCacheKey");
    }
    operation.setContext({
      headers: headers
    });
    return forward(operation);
  });
  const onErrorLink = (0, _error.onError)(_ref => {
    let {
      graphQLErrors,
      networkError,
      operation,
      forward
    } = _ref;
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        if (!Array.isArray(err) && err.message && err.message.includes("status code 401")) {
          logout();
        }
      }
    }
    if (networkError) {
      let errorMessage = "Network error - ";
      errorMessage += networkError.message;
      try {
        var _operation$query;
        errorMessage += ", ServiceName : " + (operation === null || operation === void 0 || (_operation$query = operation.query) === null || _operation$query === void 0 || (_operation$query = _operation$query.definitions[0]) === null || _operation$query === void 0 || (_operation$query = _operation$query.selectionSet) === null || _operation$query === void 0 || (_operation$query = _operation$query.selections[0]) === null || _operation$query === void 0 || (_operation$query = _operation$query.name) === null || _operation$query === void 0 ? void 0 : _operation$query.value);
      } catch {}
      _reactToastify.toast.dismiss();
      _reactToastify.toast.error(errorMessage);
      console.error("[Network error]: ".concat(errorMessage), graphQLErrors);
    }
  });
  const link = _client.ApolloLink.from([onErrorLink, new _client.HttpLink({
    uri: uri
  })]);
  return new _client.ApolloClient({
    link: (0, _client.concat)(authMiddleware, link),
    fetchOptions: {
      mode: "no-cors"
    },
    cache: cache,
    defaultOptions: defaultOptions
  });
};